import { useLayoutEffect } from 'react';

const GAP = 6;

const placeBelowOrAbove = (anchorRect, floatingRect) => {
  const fitsBelow = anchorRect.bottom + GAP + floatingRect.height <= window.innerHeight;
  const fitsAbove = anchorRect.top - GAP - floatingRect.height >= 0;
  return !fitsBelow && fitsAbove ? anchorRect.top - GAP - floatingRect.height : anchorRect.bottom + GAP;
};

export const useFloatingPosition = (anchorRef, floatingRef, isOpen) => {
  useLayoutEffect(() => {
    if (!isOpen) return undefined;

    const updatePosition = () => {
      const anchor = anchorRef.current;
      const floating = floatingRef.current;
      if (!anchor || !floating) return;
      const anchorRect = anchor.getBoundingClientRect();
      floating.style.top = `${placeBelowOrAbove(anchorRect, floating.getBoundingClientRect())}px`;
      floating.style.left = `${anchorRect.left}px`;
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);
    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [anchorRef, floatingRef, isOpen]);
};

export default useFloatingPosition;
